import { render, staticRenderFns } from "./ProductIndexTable.vue?vue&type=template&id=a9f8e212&scoped=true&"
import script from "./ProductIndexTable.vue?vue&type=script&lang=js&"
export * from "./ProductIndexTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductIndexTable.vue?vue&type=style&index=0&id=a9f8e212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f8e212",
  null
  
)

export default component.exports